import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const MarketingInvoiceRoutes = defineRoute({
    record: {
        route: {
            path: "/marketing-invoice",
            component: () => loadView(import("./MarketingInvoiceTable.vue")),
        },
    },
});
